export class Material {
    id: number;
    code: string;
    name: string;
    state: any;
}